module.exports = __webpack_public_path__ + "static/media/1009208.72d0043a.png";